import React, { useEffect } from 'react';

import { useApp } from '../store/AppContext';
import ConfirmDialog from './feedback/ConfirmDialog';
import PromptDialog from './feedback/PromptDialog';

/* Boîte de confirmation ou de saisie demandée par confirmAsk / promptAsk. Échap ou un clic à
   côté annule. */
export default function FeedbackDialog() {
  const { dialog } = useApp();
  const cancelValue = dialog?.kind === 'prompt' ? null : false;
  useEffect(() => {
    if (!dialog) return undefined;
    const onKey = (e) => e.key === 'Escape' && dialog.resolve(cancelValue);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [dialog, cancelValue]);
  if (!dialog) return null;
  return (
    <div className="modal-overlay z-[150]" onClick={() => dialog.resolve(cancelValue)}>
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="feedback-dialog-title"
        className="modal w-[440px] max-w-[92vw]"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="feedback-dialog-title" className="text-[15px] font-bold text-navy mt-0 mb-[10px]">
          {dialog.title}
        </h2>
        {dialog.kind === 'prompt' ? (
          <PromptDialog dialog={dialog} />
        ) : (
          <ConfirmDialog dialog={dialog} />
        )}
      </div>
    </div>
  );
}
